import { Box, Button } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LegacyDialog } from '~/legacy-components/LegacyDialog';
import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';
import { EmplDetailHistory } from '~/legacy-components/ScheduleHistory/components/EmplDetailHistory';
import { EmploymentHistory } from '~/legacy-components/ScheduleHistory/components/EmplHistory';
import { EmplOtherHistory } from '~/legacy-components/ScheduleHistory/components/EmplOtherHistory';

import { LegacyMuiButton } from '../LegacyForms';

import { useScheduleHistory } from './useScheduleHistory';
import { useSxStyles } from './useStyles';

export const ScheduleHistory = () => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const {
    emplHistory,
    emplDetailHistory,
    emplOtherHistory,
    isDialogOpen,
    openDialog,
    closeDialog,
  } = useScheduleHistory();

  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index: number) => {
    setToggleState(index);
  };

  return (
    <>
      <LegacyMuiButton
        onClick={openDialog}
        startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.File} />}
        sx={sxStyles.btnLeftMargin}
        data-testid="btnScheduleHistory"
      >
        {t('laHistory')}
      </LegacyMuiButton>
      <LegacyDialog
        open={isDialogOpen}
        onClose={() => closeDialog()}
        showSave={false}
        showCancel={false}
        title={`${t('laSchedule')} - ${t('laHistory')}`}
        icon={'fa fa-file-text-o'}
        sxStylesDialogPaper={sxStyles.dialogOverflow}
        sxStylesDialogContent={sxStyles.dialogOverflow}
      >
        <Box className="container">
          <Box className="blocTabs">
            <Button
              sx={toggleState === 1 ? sxStyles.activeTabs : sxStyles.tabs}
              onClick={() => toggleTab(1)}
              data-testid="employmentTab"
            >
              {t('laEmployment')}
            </Button>
            <Button
              sx={toggleState === 2 ? sxStyles.activeTabs : sxStyles.tabs}
              onClick={() => toggleTab(2)}
              data-testid="employmentDetailTab"
            >
              {t('laEmplDetail')}
            </Button>
            <Button
              sx={toggleState === 3 ? sxStyles.activeTabs : sxStyles.tabs}
              onClick={() => toggleTab(3)}
              data-testid="otherHistoryTab"
            >
              {t('laOtherHistory')}
            </Button>
          </Box>
          <Box sx={sxStyles.contentTabs}>
            <Box
              sx={toggleState === 1 ? sxStyles.activeContent : sxStyles.content}
            >
              <EmploymentHistory data={emplHistory} />
            </Box>
            <Box
              sx={toggleState === 2 ? sxStyles.activeContent : sxStyles.content}
            >
              <EmplDetailHistory data={emplDetailHistory} />
            </Box>
            <Box
              sx={toggleState === 3 ? sxStyles.activeContent : sxStyles.content}
            >
              <EmplOtherHistory data={emplOtherHistory} />
            </Box>
          </Box>
        </Box>
      </LegacyDialog>
    </>
  );
};
